import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';

export default {
  install: (app) => {
    const notyf = new Notyf({
      duration: 3000,
      position: { x: 'right', y: 'top' }
    });
    
    // Make it available globally as $toast
    app.config.globalProperties.$toast = notyf;
  }
};